module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/img_plan-49aa616b1a61b4c72fe94515cc22c6bc.jpg";